
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Docs/[slug]",
      function () {
        return require("private-next-pages/Docs/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Docs/[slug]"])
      });
    }
  